// AI / ML development pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const MACHINE_LEARNING_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'Machine Learning Development Services | Debut Infotech',
    img: cdnUrl('machine-learning-development-company/Machine-learning-development-company.jpg'),
    description:
        'Debut Infotech provides custom machine learning development services, including predictive analytics, ML model development, NLP, and MLOps to drive business growth.'
};

export const GENERATIVE_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'Generative AI Development Company | Gen AI Development Services',
    img: cdnUrl('generative-ai-development/Generative-AI-Development-Company.jpg'),
    description:
        'Accelerate innovation with our Generative AI development services. Build AI-powered solutions for automation, personalization, and business growth.'
};

export const AI_CHATBOT_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: ' AI Chatbot Development Services | Custom Chatbot Integration',
    img: cdnUrl('ai-chatbot-development/AI-Chatbot-Development-Services.jpg'),
    description:
        'Debut Infotech offers AI Chatbot Development & Integration Services powered by AI models like GPT-4o, Claude, & Gemini with LLM, RAG, and CRM integration.'
};

export const GENERATIVE_AI_CONSULTING_META_DATA: PageHeadMeta = {
    title: 'Generative AI Consultants | Generative AI Consulting Services',
    img: cdnUrl('generative-ai-consulting-company/Generative-AI-Consulting-Services.jpg'),
    description:
        'Hire our top-rated generative AI consultants. We offer expert generative AI consulting services to meet your business needs and drive innovation.'
};

export const AI_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'Artificial Intelligence (AI) Development Company | Debut Infotech',
    img: cdnUrl('ai-development-company/AI-Development-Company.jpg'),
    description:
        'Debut Infotech builds production-ready AI solutions with 15+ years of engineering expertise in custom AI development, LLM integration, RAG, AI agents, and automation.'
};

export const AI_CONSULTING_COMPANY_META_DATA: PageHeadMeta = {
    title: 'AI Consulting Company | AI Consulting Services',
    img: cdnUrl('ai-consulting-company/AI-Consulting-Services.jpg'),
    description:
        'Get custom AI development and integration services, including  AI consulting, Gen AI, LLM integration, and AI agents tailored for enterprise-scale businesses.'
};

export const CHATGPT_APPLICATION_DEVELOPERS_META_DATA: PageHeadMeta = {
    title: 'Hire ChatGPT Developers | ChatGPT Development Services',
    img: cdnUrl('chatgpt-application-developers/chat-gpt-develpers.png'),
    description:
        'Looking to hire top ChatGPT developers? Our certified experts provide exceptional ChatGPT development services utilizing the latest GPT technologies.'
};

export const GENERATIVE_AI_INTEGRATION_META_DATA: PageHeadMeta = {
    title: 'Enterprise Generative AI Integration Services | Debut Infotech',
    img: cdnUrl('generative-ai-integration/Generative-ai-integration-services.jpg'),
    description: `Integrate generative AI into enterprise applications, data, and workflows with secure RAG, LLMs, AI agents, governance, deployment, and ongoing support.`
};

export const AI_META_DATA: PageHeadMeta = {
    title: 'Artificial Intelligence (AI) Development Company & Services',
    description:
        'As a premier AI development company, we offer generative Artificial Intelligence development services in machine learning, and natural language processing.',
    img: cdnUrl('meta-images/ai-banner-image.jpg')
};

export const ARTIFICIAL_INTELLIGENCE_TECHNOLOGY: PageHeadMeta = {
    title: 'What is Artificial Intelligence | How Does AI Work',
    description:
        "Discover the key concepts of Artificial Intelligence and how AI works. Learn about technologies, and applications shaping AI's impact across industries.",
    img: cdnUrl('ai-pillar-page/ai-development-services.jpg')
};

export const AI_AGENT_DEVELOPMENT: PageHeadMeta = {
    title: 'Custom AI Agent Development Services',
    description:
        'Debut Infotech, your trusted partner for advanced Custom AI Agent Development Services. Delivering cutting-edge, tailored AI solutions to transform your business.',
    img: cdnUrl('Ai-agent-development/AI-Agent-Development-Company.jpg')
};

export const AI_COPILOT_DEVELOPMENT: PageHeadMeta = {
    title: 'AI Copilot Development Company | Build Smart Business Solutions',
    description:
        'We offer tailored AI Copilot development solutions to enhance productivity and efficiency. Leverage advanced AI to transform workflows and drive innovation.',
    img: cdnUrl('ai-copliot/Ai-copliot-development-company.jpg')
};

export const ADAPTIVE_AI_DEVELOPMENT: PageHeadMeta = {
    title: 'Adaptive AI Development Company',
    description:
        'Partner with our adaptive AI development company for intelligent, scalable solutions. Tailored to your needs, we drive innovation with cutting-edge technology!',
    img: cdnUrl('Adaptive-AI-Development/Adaptive-AI-Development-Company.jpg')
};

export const LARGE_LANGUAGE_MODEL: PageHeadMeta = {
    title: 'Large Language Model Development Company',
    description:
        'Debut Infotech specializes in large language model development, providing advanced AI solutions for businesses. Enhance your operations with cutting-edge AI technologies.',
    img: cdnUrl('LLM-development/LLM-development-company.jpg')
};

export const CHATGPT_DEVELOPMENT_SERVICES: PageHeadMeta = {
    title: 'ChatGPT Development Services | ChatGPT App Development',
    description:
        'We offer expert ChatGPT development services, providing businesses with AI-driven chatbot solutions for enhanced customer interaction and automation.',
    img: cdnUrl('ChatGPT-Applications-Development-Company/ChatGPT-Applications-Development-Company.jpg')
};

export const AI_PROMPT_ENGINEERING: PageHeadMeta = {
    title: 'AI Prompt Engineering Company & Services | Debut Infotech',
    description:
        'Partner with Debut Infotech for AI prompt engineering services that optimize LLM performance, improve response accuracy, and streamline AI workflows.',
    img: cdnUrl('AI-Prompt-Engineering/AI-Prompt-Engineering-Company.jpg')
};

export const CHATGPT_INTEGRATION_SERVICE: PageHeadMeta = {
    title: 'ChatGPT Integration Services for Businesses',
    description:
        'Get ChatGPT integration services to automate workflows, boost efficiency, and deliver outstanding customer experiences seamlessly.',
    img: cdnUrl('Chatgpt-integration-services/ChatGPT-Integration-Services.jpg')
};

export const AI_DEPLOYMENT_SERVICES: PageHeadMeta = {
    title: 'AI Deployment Company | AI Deployment Services',
    description:
        'Discover scalable AI deployment services tailored to your needs. Streamline operations, boost efficiency, and unlock growth with innovative AI solutions.',
    img: cdnUrl('AI-Deployment-Company/AI-Deployment-Company.jpg')
};

export const ML_CONSULTING_SERVICE: PageHeadMeta = {
    title: 'MLOps Consulting Services | Streamline ML Model Deployment',
    description:
        'Explore expert MLOps consulting services to streamline ML deployment, model management, and operational efficiency for your business growth.',
    img: cdnUrl('Mlops-consulting-services/MLOps-Consulting-Services.jpg')
};

export const AI_AS_A_SERVICE: PageHeadMeta = {
    title: 'AI as a Service (AIaaS) Solutions',
    description:
        'Leverage AI as a Service (AIaaS) for scalable, cost-effective AI solutions. Deploy machine learning models and AI tools with ease. Get started today!',
    img: cdnUrl('AIaaS/AI-as-a-Service.jpg')
};

export const ENTERPRISE_AI_CHATBOT_DEVELOPMENT: PageHeadMeta = {
    title: 'Enterprise AI Chatbot Development Services',
    description:
        "Boost customer engagement and operational efficiency with Debut Infotech's enterprise AI chatbot development services. Tailored solutions for seamless communication.",
    img: cdnUrl('enterprise-ai-chatbot-development/Enterprise-AI-Chatbot-Development.jpg')
};

export const ENTERPRISE_AI_DEVELOPMENT_SERVICE: PageHeadMeta = {
    title: 'Enterprise AI Development Services',
    description:
        'Accelerate business growth with our enterprise AI development services—tailored solutions to optimize operations, enhance decision-making, and drive innovation.',
    img: cdnUrl('Enterprise-AI-Development/Enterprise-AI-Development-Company.jpg')
};

export const NATURAL_LANGUAGE_PROCESSING_DEVELOPMENT: PageHeadMeta = {
    title: 'NLP Development Company | NLP Development Services',
    description:
        'Partner with a leading Natural Language Processing (NLP) company offering cutting-edge NLP development services to enhance automation and language insights.',
    img: cdnUrl('NLP-Development-Services/NLP-Development-Services.jpg')
};

export const WHAT_IS_MACHINE_LEARNING: PageHeadMeta = {
    title: 'What is Machine Learning | How Does ML Work',
    description:
        'Discover the fundamentals of Machine Learning, how it works, key techniques, and its impact across industries. Dive into ML concepts, models, and real-world applications.',
    img: cdnUrl('ML-Pillar-page/Machine-Learning.jpg')
};

export const DEEP_LEARNING_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'Deep Learning Development Company | Deep Learning Services',
    description:
        'Our Deep Learning Development Company delivers end-to-end Deep Learning Services to build AI models, automate workflows, and drive smarter business decisions.',
    img: cdnUrl('Deep-learning-development/Deep-Learning-Development-Services.jpg')
};

export const AI_DEVELOPMENT_AGENCY_IN_UK: PageHeadMeta = {
    title: 'AI Development Agency in the UK | Debut Infotech',
    description:
        'Debut Infotech is a UK-based AI development agency delivering custom AI solutions, intelligent automation, and data-driven systems for businesses.',
    img: cdnUrl('AI-Development-Agency-in-UK/AI-Development-Agency-in-UK.jpg')
};

export const AI_DEVELOPMENT_SERVICE_IN_UK: PageHeadMeta = {
    title: 'AI Development Service in UK | Debut Infotech',
    img: cdnUrl('AI-Development-Agency-in-UK/AI-Development-Agency-in-UK.jpg'),
    description:
        'Expert AI development service in the UK — helping enterprises convert data into a strategic asset with bespoke AI solutions that drive operational efficiency and measurable business outcomes.'
};

export const LLM_FINE_TUNING_META_DATA: PageHeadMeta = {
    title: 'LLM Fine Tuning Services | Debut Infotech',
    img: cdnUrl('meta-images/Hero_Graphic.jpg'),
    description:
        'Looking to improve LLM accuracy for your business? Debut Infotech offers LLM fine-tuning services to enhance model performance, relevance, and real-world results.'
};
